import Sparkle from "@/components/Sparkle";

const ITEMS = [
  "Dry hire mobile bar",
  "Serving La Cantera — Boerne",
  "Weddings",
  "Birthdays",
  "Corporate mixers",
  "Signature cocktails",
  "We roll in, you raise a glass",
];

export default function Marquee() {
  const row = (keyPrefix) => (
    <div key={keyPrefix} className="flex shrink-0 items-center">
      {ITEMS.map((item, i) => (
        <span key={`${keyPrefix}-${i}`} className="flex items-center">
          <span className="whitespace-nowrap px-8 font-display text-2xl italic tracking-wide text-blush sm:text-3xl">
            {item}
          </span>
          <Sparkle className="h-4 w-4 shrink-0 text-gold" />
        </span>
      ))}
    </div>
  );

  return (
    <section
      data-testid="marquee-strip"
      aria-label="Shaken Society services"
      className="marquee overflow-hidden border-y border-cream/10 bg-espresso-deep py-6"
    >
      <div className="marquee-track flex w-max">
        {row("a")}
        {row("b")}
      </div>
    </section>
  );
}